export default __webpack_public_path__ + "static/media/bg-right.d4d11423.svg";